import { AtSignIcon } from "@chakra-ui/icons";
import {
    Alert,
    AlertDescription,
    AlertTitle,
    Box, Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerFooter,
    DrawerHeader,
    DrawerOverlay,
    Link
} from "@chakra-ui/react";
import * as React from "react";
import { HelpFAQ } from "./helpFAQ";
export interface HelpBannerProps {
  isOpen: boolean;
  onClose: () => void;
  btnRef: React.RefObject<HTMLButtonElement>;
}
export const HelpBanner = ({ isOpen, onClose, btnRef }: HelpBannerProps) => {
  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size="md"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton colorScheme="wishlist" />
          <DrawerHeader color={"wishlist.700"}>Le domande più frequenti</DrawerHeader>

          <DrawerBody>
            <HelpFAQ />
          </DrawerBody>

          <DrawerFooter>
            <Alert status="info" colorScheme="wishlist">
              <AtSignIcon color="wishlist.500" m="0.4em" fontSize="2xl" />
              <Box flex="1">
                <AlertTitle color="wishlist.700">
                  Non hai trovato la soluzione al tuo problema?
                </AlertTitle>
                <AlertDescription color="wishlist.700" display="block">
                  Chiamaci allo{" "}
                  <Link fontWeight="bold" href="tel:0236638510">
                    02 3663 8510
                  </Link>{" "}
                  o scrivici a{" "}
                  <Link fontWeight="bold" href="mailto:ordini@wishlist.it">
                    ordini@wishlist.it
                  </Link>
                  .
                </AlertDescription>
              </Box>
            </Alert>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
